import React, { Component } from 'react';
import { Col, Form, Input, Modal, Row, Select } from 'antd';

import { queryBusinessInfo, queryCustomDepartmentList } from '@api/crm/crm';
import SelectCustom from '../SelectCustom';

const { Option } = Select;
const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (this.props.uuid) {
      this.getBusiness();
    }
  }

  getMyCustom = params => {
    return new Promise((resolve, reject) => {
      queryCustomDepartmentList({ ...params }).then(res => {
        if (res.statusCode === 200) {
          resolve(res.data.customs);
        } else {
          reject(res);
        }
      });
    });
  };

  getBusiness = () => {
    queryBusinessInfo({
      uuid: this.props.uuid,
    }).then(() => {});
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handleSubmit } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        handleSubmit(values);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const ItemLayout2 = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };
    const { handleModalVisible, product } = this.props;

    return (
      <Modal
        title="添加客户保护"
        visible
        onCancel={() => handleModalVisible(false)}
        onOk={this.submit}
      >
        <Form onSubmit={this.submit}>
          <Row>
            <Col span={24}>
              <SelectCustom {...this.props} ItemLayout={ItemLayout2} loaddata={this.getMyCustom} />
            </Col>
            <Col span={24}>
              <FormItem label="产品" {...ItemLayout2}>
                {getFieldDecorator('product', {
                  rules: [{ required: true, message: '请选择产品!' }],
                })(
                  <Select>
                    {product.map(item => {
                      return <Option key={item.name}>{item.name}</Option>;
                    })}
                  </Select>,
                )}
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem label="成单金额" {...ItemLayout2}>
                {getFieldDecorator('amount', {
                  rules: [{ required: true, message: '请输入成单金额!' }],
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/custom/protect/ModalProtect.js